import { PasstDetalleCompletarModel } from "./PasstDetalleCompletarModel";

export class PasstCompletarModel{
    idPasst: number;
    comentarios: string;
    actividades: Array<PasstDetalleCompletarModel>;
    constructor(){
        
        this.actividades = new Array<PasstDetalleCompletarModel>();
        this.idPasst = 0;
        this.comentarios = '';
    }
}